/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Sends the old forum index address, /forum or /forum/, to the forum.
 *
 * Installed Deskshare applications still open /forum/ (singular). The server
 * answers it with a permanent redirect (nginx.conf); this route is the same
 * rule for a host that serves the app without that configuration, where the
 * catch-all would otherwise draw the home page. The query string is kept.
 * Only the index: the route matches these two addresses exactly.
 */

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PageLoader from "@/components/common/PageLoader";
import { getForumUrl } from "@/utils/siteConfig";

/** The forum's index address, with the query string kept. */
function forumIndexAddress(search: string): string {
  return `${getForumUrl().replace(/\/+$/, "")}/${search}`;
}

const OldForumIndex: React.FC = () => {
  const { search } = useLocation();
  useEffect(() => {
    window.location.replace(forumIndexAddress(search));
  }, [search]);
  return <PageLoader />;
};

export default OldForumIndex;
